import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { SQLService } from '../../services/sql.service';
import { Flip } from '../../app.animations';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ModalController, NavParams } from '@ionic/angular';
@Component({
  selector: 'ng-cheques-select-schedule',
  templateUrl: './select-schedule.page.html',
  styleUrls: ['./select-schedule.page.styl'],
  animations: [ Flip ]
})
export class SelectSchedulePage implements OnInit {
  constructor(
    private router: Router,
    public sql: SQLService,
    private route: ActivatedRoute,
    private navCtrl: ModalController,
    private location: Location,
    private params: NavParams,
) {
    var s = params.get('selected');
    if(s)this.selected = s.split(',');
    this.multiple = params.get('select_multiple');
    this.router.events.subscribe((eve) => {
      if(eve instanceof NavigationEnd) this.get_schedules();
    });
  }
  count = -1;
  schedules = [];
  selected = [];
  multiple: boolean;
  output = new EventEmitter();
  @Input('set_table') table:string;
  @Input('set_model') model:string;
  @Input('set_model_id') id:string;
  ngOnInit() {
    this.get_schedules();
    this.id = this.route.snapshot.paramMap.get("id");
    this.table = this.route.snapshot.paramMap.get("table");
    this.model = this.route.snapshot.paramMap.get("model");
  }
  get_schedules(event?) {
    this.sql.fetch('Schedules',(e)=>{
      this.schedules=e;
      this.count=e.length;
      setTimeout(()=>{if (event) event.target.complete();},1234);
    });
  }
  add() {
    this.sql.count('Schedules',(c)=>{
      if(this.sql.Trial && this.sql.Trial_Schedules!=-1 && c>=this.sql.Trial_Schedules) {
        this.sql.show_purhchase_modal();
      } else {this.router.navigate(['folder','Schedule','New']);}
    });
    this.navCtrl.dismiss();
  }
  off() {
    // this.location.back();
    if(this.multiple){
      this.done_multiple();
     } else {
      this.navCtrl.dismiss();
     }
  }
  select_none() {this.navCtrl.dismiss(-1);}
  select(e) {
    if(this.multiple){
      this.toggle_item(e);
    } else {
      this.navCtrl.dismiss(e);
    }
  }
  done_multiple() {
    var j = this.selected.join(',');
    this.navCtrl.dismiss(j);
  }
  toggle_item(item) {
    if( this.selected.includes(item.schedule_id) ) {
      this.deselect_item(item);
    } else {
      this.select_item(item);
    }
  }
  select_item(item) {
    console.log(item.schedule_id);
    this.selected.push(item.schedule_id);
  }
  deselect_item(item) {
    var new_selection=[];
    for(var i = 0; i < this.selected.length; ++i){
      if(this.selected[i]!=item.schedule_id){
        new_selection.push(this.selected[i]);
      }
    }
    this.selected = new_selection;
  }
  select_all() {
    var new_selection=[];
    for (var i = 0; i < this.schedules.length; ++i) {
      new_selection.push(this.schedules[i].tax_id);
    }
    this.selected=new_selection;
  }
  deselect_all() {
   this.selected = []; 
  }
}